const BACKEND_BASE = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:3001/api/v1';
const TENANT_SLUG = process.env.REACT_APP_TENANT_SLUG;

function withTenantHeaders(options = {}) {
  const headers = { ...(options.headers || {}) };
  if (TENANT_SLUG) headers['x-tenant-slug'] = TENANT_SLUG;
  return { ...options, headers };
}

async function uploadRequest(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    ...options,
  });
  
  if (res.status === 401) {
    // Redirect to login on unauthorized
    if (typeof window !== 'undefined') {
      const here = window.location.pathname + window.location.search;
      const to = here.includes('/login') ? '/login' : `/login?next=${encodeURIComponent(here)}`;
      if (!window.location.pathname.startsWith('/login')) window.location.assign(to);
    }
    throw new Error('Unauthorized');
  }
  
  if (!res.ok) {
    let body;
    try { body = await res.json(); } catch (_) { body = { error: res.statusText }; }
    throw new Error(body?.error || `Upload failed (${res.status})`);
  }
  
  try { return await res.json(); } catch (_) { return null; }
}

export const uploadAPI = {
  // Upload single image file
  async uploadImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    
    const json = await uploadRequest(
      `${BACKEND_BASE}/upload/image`, 
      withTenantHeaders({
        method: 'POST',
        body: formData
      })
    );
    
    return json;
  },

  // Upload multiple image files
  async uploadImages(files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('images', file);
    });
    
    const json = await uploadRequest(
      `${BACKEND_BASE}/upload/images`, 
      withTenantHeaders({
        method: 'POST',
        body: formData
      })
    );
    
    return json;
  },

  // Delete uploaded file
  async deleteImage(filename) {
    const json = await uploadRequest(
      `${BACKEND_BASE}/upload/image/${encodeURIComponent(filename)}`, 
      withTenantHeaders({
        method: 'DELETE'
      })
    );
    
    return json;
  },

  // Convert file to base64 (fallback for compatibility)
  async fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
};
